module.exports = __webpack_public_path__ + "static/media/lisaheute.190282a0.JPG";